"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Uploader = void 0;
const tslib_1 = require("tslib");
const uploader_uppy_1 = require("./uploader.uppy");
const uploader_youtube_1 = require("./uploader.youtube");
class Uploader {
    constructor(type, options) {
        this.uppyUploader = new uploader_uppy_1.UppyUploader(type, options);
        this.youtubeUploader = new uploader_youtube_1.YoutubeUploader({
            theme: options.theme,
        });
        this.uppy = this.uppyUploader.getUppy();
        this.type = type;
        this.theme = options.theme;
        this.addUppyEventListener(options);
    }
    addUppyEventListener(options) {
        this.uppy.on('file-added', (file) => {
            var _a;
            if (!file.remote && ((_a = file.type) === null || _a === void 0 ? void 0 : _a.includes('image'))) {
                this.getImageDimension(file).then((dimensions) => {
                    this.uppy.setFileMeta(file.id, {
                        dimensions,
                    });
                });
            }
            if (options.onFileAdded) {
                options.onFileAdded(file);
            }
        });
        if (options.onFileUploaded) {
            this.uppy.on('upload-success', options.onFileUploaded);
        }
        if (options.onCompleted) {
            this.uppy.on('complete', this.formatOutput(options.onCompleted));
        }
    }
    formatUploadURL(item) {
        let url = item.uploadURL;
        if ((!url || url === 'null') && item.xhrUpload && item.xhrUpload.endpoint) {
            url = `${item.xhrUpload.endpoint}/${item.meta.name}`;
        }
        return decodeURIComponent(url);
    }
    formatOutput(onCompleted) {
        return (result) => {
            if ((result === null || result === void 0 ? void 0 : result.successful.length) > 0) {
                result.successful = result.successful.map((item) => (Object.assign(Object.assign({}, item), { uploadURL: this.formatUploadURL(item) })));
            }
            return onCompleted === null || onCompleted === void 0 ? void 0 : onCompleted(result);
        };
    }
    getImageDimension(file) {
        return new Promise((resolve, reject) => {
            const data = file.data; // is a Blob instance
            const url = URL.createObjectURL(data);
            const image = new Image();
            image.src = url;
            image.onload = () => {
                URL.revokeObjectURL(url);
                resolve({
                    width: image.width,
                    height: image.height,
                });
            };
            image.onerror = (error) => {
                URL.revokeObjectURL(url);
                reject(error);
            };
        });
    }
    openDashboard(onCompleted, onImportYoutubeVideo) {
        const dashboard = this.uppy.getPlugin('Dashboard');
        const container = dashboard === null || dashboard === void 0 ? void 0 : dashboard.el;
        if (container && this.type === 'video' && onImportYoutubeVideo) {
            this.youtubeUploader.createYoutubeButton(container, onImportYoutubeVideo, () => this.closeDashboard());
        }
        this.uppyUploader.off('complete');
        if (onCompleted) {
            onCompleted && this.uppy.once('complete', this.formatOutput(onCompleted));
        }
        dashboard === null || dashboard === void 0 ? void 0 : dashboard.openModal();
    }
    closeDashboard() {
        const dashboard = this.uppy.getPlugin('Dashboard');
        dashboard === null || dashboard === void 0 ? void 0 : dashboard.closeModal();
    }
    close() {
        this.uppy.close();
    }
    uploadImage(blob, imageName, mimeType) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.uppy.addFile({
                name: imageName,
                type: mimeType,
                data: blob,
            });
            yield this.uppy.upload();
        });
    }
}
exports.Uploader = Uploader;
//# sourceMappingURL=uploader.js.map